import { useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import { apiFetch } from '../../api/api';
import { getVideoDuration } from '../../utils/media/getVideoDuration';
import { useOrg } from '../../pages/orgs/org-context';

const MAX_VIDEO_SECONDS = 15;

const UploadMediaPanel = ({ onUploaded, datasetId = null, dataDocId = null }) => {
  const [uploading, setUploading] = useState(false);
  const { activeOrgId } = useOrg();

  const [publicUrl, setPublicUrl] = useState('');
  const [publicThumb, setPublicThumb] = useState('');
  const [mediaType, setMediaType] = useState(null);

  const handleDrop = async (files) => {
    if (!activeOrgId) {
      toast.error('Please select an organization before uploading media');
      return;
    }

    const file = files[0];
    if (!file) return;

    const isVideo = file.type.startsWith('video');
    const type = isVideo ? 'video' : 'image';

    setMediaType(type);
    setUploading(true);
    setPublicUrl('');
    setPublicThumb('');

    try {
      // 🎬 optional video validation
      if (isVideo) {
        const duration = await getVideoDuration(file);
        // if (duration > MAX_VIDEO_SECONDS) { ... }
      }

      // 1️⃣ signed upload URL
      const { uploadUrl, bucket, key } = await apiFetch('/media/upload-url', {
        method: 'POST',
        body: {
          mimeType: file.type,
          originalName: file.name,
          type
        }
      });

      // 2️⃣ upload to S3
      await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file
      });

      // 3️⃣ create DB record
      const created = await apiFetch('/media', {
        method: 'POST',
        body: {
          datasetId,
          dataDocId,
          type,
          s3Key: key,
          s3Bucket: bucket,
          mimeType: file.type,
          originalName: file.name,
          size: file.size
        }
      });

      // 4️⃣ build public URL
      const mediaUrl = `https://${bucket}.s3.amazonaws.com/${key}`;
      setPublicUrl(mediaUrl);

      // 5️⃣ thumbnail logic
      if (created.type === 'video') {
        setPublicThumb(created.thumbnailUrl);
      } else {
        setPublicThumb(mediaUrl);
      }

      toast.success('Media uploaded');
      onUploaded?.();

    } catch (err) {
      console.error(err);
      toast.error('Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-panel-vertical">

      <Dropzone
        onDrop={handleDrop}
        multiple={false}
        disabled={!activeOrgId}
        accept={{
          'image/*': [],
          'video/*': []
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="dropzone">
            <input {...getInputProps()} />
            {uploading ? 'Uploading…' : 'Click or drop image / video'}
          </div>
        )}
      </Dropzone>

      {/* PREVIEW — always thumbnail in admin */}
      {publicThumb && (
        <div className="upload-preview">
          <img src={publicThumb} alt="Preview" />
        </div>
      )}

    </div>
  );
};

export default UploadMediaPanel;
